import { TrackLinkDirective } from '@analytics/events';
import { NgClass } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { JssPlatformService } from '@core/jss-platform';
import {
  CoreJssProxyModule,
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';
import { GenericLinkDirective } from '@core/jss-utils';
import { CrntIcon } from '@essent/current-web-angular';
import type { A11YLinkField } from '@core/jss-models';

import {
  AspectRatio,
  InformationCardComponent,
} from '../information-card/information-card.component';

export interface InformationCard {
  id: string;
  title: TextField;
  content: RichTextField;
  button: A11YLinkField;
  image?: ImageField;
}

const MAX_CARDS = 4;

@Component({
  selector: 'wl-information-card-row',
  standalone: true,
  imports: [
    CoreJssProxyModule,
    InformationCardComponent,
    NgClass,
    CrntIcon,
    TrackLinkDirective,
    GenericLinkDirective,
  ],
  templateUrl: './information-card-row.component.html',
  styleUrls: [
    './information-card-row.component.ed.scss',
    './information-card-row.component.essent.scss',
  ],
})
export class InformationCardRowComponent {
  readonly #jssPlatformService = inject(JssPlatformService);

  readonly title = input.required<TextField>();
  readonly cards = input.required<InformationCard[]>();
  readonly align = input<'left' | 'center'>('center');
  readonly content = input<RichTextField>();
  readonly link = input<LinkField>();

  readonly isContentEditorActive = this.#jssPlatformService.isEditorActive();

  readonly aspectRatio = computed<AspectRatio>(() => {
    const cardCount = this.cards().length;
    return cardCount === MAX_CARDS ? '1/1' : '4/3';
  });
}
